import { Grid, Checkbox, Tooltip, Box, useTheme } from '@mui/material'
import FormControlLabel from '@mui/material/FormControlLabel';

const styles = {
    toggleSettingsBox: {
        backgroundColor: 'var(--spectre-surface)',
        textArea: {
            color: 'var(--spectre-text-secondary)',
        },
        mt: 1
    }
}

export default function ToggleSetting(props: any) {
    const { display_name, element, setSettingsArray, index, disabledState, navigateToMatchmaking } = props;
    const theme = useTheme();
    const checkboxSx = theme.palette.mode === 'dark'
        ? { color: '#FFFFFF', '&.Mui-checked': { color: '#FFFFFF' } }
        : undefined;

    interface ElementType {
        value: string | boolean;
        Tooltip?: string;
        Set: (checked: boolean) => Promise<void>;
    }

    const control = <FormControlLabel
        disabled={disabledState}
        sx={{
            color: 'var(--spectre-settings-text-primary)',
            '& .MuiFormControlLabel-label': {
                color: 'var(--spectre-settings-text-primary)',
            },
        }}
        control={
            <Checkbox
                sx={checkboxSx}
                defaultChecked={JSON.parse(element.value)}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    element.Set(e.target.checked)
                        .catch(() => {
                            navigateToMatchmaking();
                        });

                    setSettingsArray((old: ElementType[]) => {
                        let copy = [...old];
                        copy[index].value = !JSON.parse(element.value);
                        return copy;
                    });
                }}
            />
        }
        label={display_name}
    />;

    return (
        <Grid item xs={12} lg={6} sx={styles.toggleSettingsBox} >
            {element.Tooltip && element.Tooltip !== "no name" ?
                <Tooltip title={element.Tooltip} placement="top">
                    {/* The Box is necessary to ensure the tooltip appears when the control is disabled */}
                    <Box component="span" sx={{ display: 'block' }}>
                        {control}
                    </Box>
                </Tooltip>
                :
                control
            }
        </Grid>
    )
}